/** File picker accept list for raster uploads stored through the storage module. */
export const IMAGE_UPLOAD_ACCEPT =
  'image/jpeg,image/png,image/webp,image/heic,image/heif,.jpg,.jpeg,.png,.webp,.heic,.heif';
